// extracted by mini-css-extract-plugin
export var img = "Image-module--img--9f6b7";